import React, { useEffect, useState } from "react";
import { useIdleTimerContext } from "react-idle-timer";
import { Box, Button, Typography } from "@mui/material";
import BaseModal from "./BaseModal";

const InactivityModal = ({ onClose, open }) => {
  const [remaining, setRemaining] = useState(0);
  const { activate, getRemainingTime } = useIdleTimerContext();

  useEffect(() => {
    const interval = setInterval(() => {
      setRemaining(Math.ceil(getRemainingTime() / 1000));
    }, 500);

    return () => {
      clearInterval(interval);
    };
  }, []);

  const handleClose = () => {
    onClose();
    activate();
  };

  if (!open) {
    return null;
  }

  return (
    <BaseModal headline="Are you still here?" onClose={handleClose} gradient={true}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
        }}
      >
        <Typography sx={{ width: "100%" }} align="center">
          Logging out in {remaining} {remaining > 1 ? "seconds" : "second"}
        </Typography>
        <Button
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: "280px",
          }}
          onClick={activate}
        >
          {"I'm still here"}
        </Button>
      </Box>
    </BaseModal>
  );
};

export default InactivityModal;
